import { memo } from "react";
import { StatusTag } from "../../../atoms/Tag";

const resolveDetailPageStatus = status => {
  if (!status) return null;
  if (typeof status === "string") return status;
  return status?.name ?? status?.id ?? null;
};

/**
 * Inline status pill for detail page top bars.
 */
const DetailPageTopBarStatus = memo(({ status }) => {
  const statusName = resolveDetailPageStatus(status);
  if (!statusName) return null;

  return <StatusTag className={statusName}>{statusName}</StatusTag>;
});

export { DetailPageTopBarStatus, resolveDetailPageStatus };
